/**
 * 专题列表页内存缓存（SPA 会话内有效，刷新页面会清空）。
 * 首次请求后再次进入同一分类/分页时先秒开，再在后台拉最新数据。
 */

const MAX_KEYS = 80
const cache = new Map() // key -> { records, total, ts }

function keyOf(categoryId, current, size, keyword) {
  return `${categoryId}|${current}|${size}|${(keyword || '').trim()}`
}

export function getSeriesListCache(categoryId, current, size, keyword) {
  if (!categoryId) return null
  const k = keyOf(categoryId, current, size, keyword)
  const v = cache.get(k)
  return v ? { ...v } : null
}

export function setSeriesListCache(categoryId, current, size, keyword, records, total) {
  if (!categoryId) return
  const k = keyOf(categoryId, current, size, keyword)
  if (cache.size >= MAX_KEYS) {
    const first = cache.keys().next().value
    cache.delete(first)
  }
  cache.set(k, {
    records: Array.isArray(records) ? [...records] : [],
    total: total ?? 0,
    ts: Date.now()
  })
}

/** 更新当前 key 下某条专题的收藏状态（与列表同步） */
export function patchSeriesInCache(categoryId, current, size, keyword, seriesId, patch) {
  const k = keyOf(categoryId, current, size, keyword)
  const v = cache.get(k)
  if (!v?.records) return
  const idx = v.records.findIndex((r) => r.id === seriesId)
  if (idx === -1) return
  v.records[idx] = { ...v.records[idx], ...patch }
}

let categoriesCache = null
let categoriesTs = 0
const CATEGORIES_TTL_MS = 10 * 60 * 1000

export function getCategoriesCache() {
  if (categoriesCache && Date.now() - categoriesTs < CATEGORIES_TTL_MS) {
    return categoriesCache
  }
  return null
}

export function setCategoriesCache(list) {
  categoriesCache = Array.isArray(list) ? [...list] : []
  categoriesTs = Date.now()
}
